import { APLCategoryManager } from "./apl-category-manager.model";
import { APLCategoryMaster } from "./apl-category-master.model";
import { APLCategory } from "./apl-category.model";
import { APLGroup } from "./apl-group.model";

export class APLContainer {
  public id!: number;
  public name!: string;
  public type!: number;
  public aplCategories!: APLCategory[];
  public open?: boolean;
  public hasMatch?: boolean;


  // public id!: number;
  // public name!: string;
  // public code!: string;
  // public status!: number;
  // public type!: number;
  // public aplCategoryMasterID!: number;
  // public previousVersionID!: number;
  // public version!: number;
  // public createdBy!: number;
  // public aplCategoryMaster!: APLCategoryMaster;
  // public aplCategoryManagers: APLCategoryManager[];
  // public previousVersion!: APLCategory;
  // public newVersion?: APLCategory;
  // public aplGroups?: APLGroup[];

  // public open?: boolean;
  // public pendingGroups?: boolean;

  constructor() {
    // this.aplCategoryManagers = [];
    this.aplCategories = [];
  }
}
